import { connect } from 'react-redux';
import WebhookForm from './WebhookForm';

import {
  createWebhookRequest,
  webhookDetailsRequest,
  updateWebhookRequest,
  webhooksRequest,
} from '../../redux/actions/webhooks';
import { selectWebhook, selectWebhooks } from '../../redux/selectors/webhooks';
import { AppState } from '../../redux/store';
import { getBuilderId, getEnterpriseId, selectEnterpriseStatus } from '../../redux/selectors/auth';
import { selectBuilders, selectBuildersRequestStatus } from '../../redux/selectors/builders';
import { enterpriseBuildersRequest } from '../../redux/actions/builders';
import { propertiesByCommunityRequest } from '../../redux/actions/properties';

const mapStateToProps = (state: AppState) => ({
  webhooks: selectWebhooks(state),
  selectedWebhook: selectWebhook(state),
  isEnterprise: selectEnterpriseStatus(state.auth),
  enterpriseId: getEnterpriseId(state),
  builderId: getBuilderId(state),
  enterpriseBuilders: selectBuilders(state),
  loadingEnterpriseBuilders: selectBuildersRequestStatus(state),
});

const mapDispatchToProps = {
  createWebhook: createWebhookRequest,
  updateWebhook: updateWebhookRequest,
  loadWebhooks: webhooksRequest,
  loadWebhookById: webhookDetailsRequest,
  loadEnterpriseBuilders: enterpriseBuildersRequest,
  loadCommunityProperties: propertiesByCommunityRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookForm);
